import React, { useEffect, useState } from 'react';
import { fetchPlantsByName } from '../../../api/api_plants';
import { fetchCustomPlantsByName } from '../../../api/api_customPlants';
import loadDynamicImage from '../../Entities/ImageLoader';
import loadingGif from '../../assets/loading.gif';
import defaultPlant from '../../assets/plants/defaultPlant.jpg';

const PlantDetailsModal = ({
  plantName,
  isCustom = false,
  customPlantObj = null,
  onClose,
  translations
}) => {
  const [plant, setPlant] = useState(null);
  const [error, setError] = useState('');

  const sunlightLevelMapping = {
    0: translations.no_light,
    1: translations.low_ambient_light,
    2: translations.ambient_light,
    3: translations.indirect_solar_light,
    4: translations.direct_solar_light,
  };

  const getSunlightLevelText = (sunlight_level) => {
    return sunlightLevelMapping[sunlight_level] || translations.unknown_sunlight_level;
  };

  useEffect(() => {
    setError('');
    setPlant(null);

    if (isCustom) {
      // Usa el objeto si lo tienes
      if (customPlantObj) {
        setPlant(customPlantObj);
      } else if (plantName) {
        // Si solo tienes el nombre, haz el fetch custom
        fetchCustomPlantsByName(plantName).then(response => {
          if (response && response.data && response.data.length > 0) {
            setPlant(response.data[0]);
          } else {
            setError(translations.plant_not_found);
          }
        }).catch(() => setError(translations.error_fetching_plant_details));
      }
    } else if (plantName) {
      // Planta normal
      fetchPlantsByName(plantName).then(response => {
        if (response && response.data && response.data.length > 0) {
          setPlant(response.data[0]);
        } else {
          setError(translations.plant_not_found);
        }
      }).catch(() => setError(translations.error_fetching_plant_details));
    }
  }, [plantName, isCustom, customPlantObj, translations]);

  if (!plantName && !customPlantObj) return null;

  return (
    <div className="plant-modal-overlay" onClick={onClose}>
      <div className="plant-modal-content" onClick={e => e.stopPropagation()}>
        <button className="plant-modal-close" onClick={onClose} aria-label="Close modal">
          <span>&times;</span>
        </button>
        <div className="plant-modal-header">
          <div className="plant-avatar-container">
            <img
              className="plant-modal-avatar"
              src={
                plant
                  ? (loadDynamicImage(plant?.name || 'defaultPlant') || defaultPlant)
                  : loadingGif
              }
              alt={plant?.name || translations.loading}
            />
          </div>
          <h2 className="plant-modal-title">{plant?.name}</h2>
        </div>
        {error && <p className="plant-modal-error">{error}</p>}
        {plant ? (
          <div className="plant-modal-info-list">
            <div>
              <span className="plant-modal-label">{translations.ideal_temperature}:</span>
              <span className="plant-modal-value">{plant.max_temperature} - {plant.min_temperature} ºC</span>
            </div>
            <div>
              <span className="plant-modal-label">{translations.ideal_minerals}:</span>
              <span className="plant-modal-value">{plant.max_minerals} - {plant.min_minerals} PPM</span>
            </div>
            <div>
              <span className="plant-modal-label">{translations.ideal_ground_humidity}:</span>
              <span className="plant-modal-value">{plant.max_ground_humidity} - {plant.min_ground_humidity} %</span>
            </div>
            <div>
              <span className="plant-modal-label">{translations.ideal_air_humidity}:</span>
              <span className="plant-modal-value">{plant.max_air_humidity} - {plant.min_air_humidity} %</span>
            </div>
            <div>
              <span className="plant-modal-label">{translations.sunlight_level}:</span>
              <span className="plant-modal-value">{getSunlightLevelText(plant.sunlight_level)}</span>
            </div>
          </div>
        ) : (
          <div className="plant-modal-loading">
            <img src={loadingGif} alt={translations.loading} />
          </div>
        )}
      </div>
    </div>
  );
};

export default PlantDetailsModal;
